import TimeTagWatch from "../../views/portfolio/TimeTagWatch";
import UnderArmour from "../../views/portfolio/UnderArmour";
import ReStyling from "../../views/portfolio/ReStyling";
import ToastReel from "../../views/portfolio/ToastReel";
import WhatIfGold from "../../views/portfolio/WhatIfGold";
import NileKabutha from "../../views/portfolio/NileKabutha";
import SleepWalker from "../../views/portfolio/SleepWalker";
import NovaraConic from "../../views/portfolio/NovaraConic";
import BastianBux from "../../views/portfolio/BastianBux";

const data = [
    {
        id: 1,
        title: "Malaysia",
        slug: 'malaysia',
        category: ['Asia'],
        description: 'Sometimes, we need to check the time, wondering when our work or meeting will finish, without getting caught by others.',
        src: '/assets/img/country/malaysia.jpg',
        srcSlider: '/assets/img/country/malaysia.jpg',
        overlay: 2,

        description: `Whoever said “It’s not about the destination. It’s the journey” never flew on a long ...`,

        requirementsFor: 'For : Diploma, Advanced Diploma, Bachelor’s and Master’s.',
        documents: ['Academic documents - Scanned copy + Photocopy (Photocopy need to be notarized )',
            'Medium of Instruction - MOI (If applicable)',
            'IELTS score - Starts from overall 5.5, No module less than 5. (Minimum 6.5 for science/commerce subjects at top universities)',
            'TOEFL (72 minimum score) ,PTE, MUET is accepted',
            'Curriculum Vitae',
            'Statement of Purpose ',
            'Recommendation letter (If required)'
        ],
        studyGap: ['No more than 8 academic years since last education(Can vary) '],
        funding: ['Bank statement with a maturity of 3 months : Must have 1 year tuition fee’s + living expense.'],
        breakdown: ['1. Bangladeshi Passport - Check local office for cost. ',
            '2. Police clearance- 500 Taka (We will provide service if required)',
            '3. Consultancy file opening fee - 10,000 Taka',
            '4. Application fee  Depends on choice of college/university.',
            '5. Tuition fee - Depends on choice of College/University. ',
            '6. Visa Application fee - 2600 to 3500 RM',
            '7. Agency service charge - 45,000 Taka',
            '8. Air ticket - Depends (We can provide)',
        ],
        checklist: ['1. All documents photocopy need to be notarized. ',
            '2. Application fee, file opening fee cannot be refunded.',
            '3. Personal expenses like plane ticket and shopping are not a part of bank statement.'
        ],

        accommodationCost: 'RM 6,000 to RM 12,000 per year',
        tuitionFee: ['Diploma: Tuition fees for diploma programs can range from RM 10,000 to RM 20,000 per year.',
            "Bachelor: Tuition fees for bachelor's programs typically range from RM 15,000 to RM 35,000 per year.",
            "Master: Tuition fees for master's programs generally range from RM 20,000 to RM 45,000 per year."
        ],
        availableIntakes: ['January/February intake',
            'July/August intake'
        ],
        component: (props) => <TimeTagWatch {...props} />
    },
    {
        id: 2,
        title: "United States of America (USA)",
        slug: 'usa',
        src: '/assets/img/country/usa.jpg',
        srcSlider: '/assets/img/country/usa.jpg',
        category: ['North-America'],
        description: 'Cal was first. The first public university in the great state of California. They are the pioneers. They are the trailblazers who started it all.',
        description: `Whoever said “It’s not about the destination. It’s the journey” never flew on a long ...`,

        requirementsFor: 'For : Diploma, Advanced Diploma, Bachelor’s and Master’s.',
        documents: ['Academic documents - Scanned copy + Photocopy (Photocopy need to be notarized )',
            'Medium of Instruction - MOI (If applicable)',
            'IELTS score - Starts from overall 5.5, No module less than 5. (Minimum 6.5 for science/commerce subjects at top universities)',
            'TOEFL ,PTE, MUET is accepted',
            'Curriculum Vitae',
            'Statement of Purpose ',
            'Recommendation letter (If required)'
        ],
        studyGap: ['No more than 8 academic years since last education(Can vary) '],
        funding: ['Bank statement with a maturity of 3 months : Must have 1 year tuition fee’s + living expense.'],
        breakdown: ['1. Bangladeshi Passport - Check local office for cost. ',
            '2. Police clearance- 500 Taka (We will provide service if required)',
            '3. Consultancy file opening fee - 10,000 Taka',
            '4. Application fee  Depends on choice of college/university.',
            '5. Tuition fee - Depends on choice of College/University. ',
            '6. Visa Application fee - 100 to 200 USD',
            '7. Agency service charge - 45,000 Taka',
            '8. Air ticket - Depends (We can provide)',
        ],
        checklist: ['1. All documents photocopy need to be notarized. ',
            '2. Application fee, file opening fee cannot be refunded.',
            '3. Personal expenses like plane ticket and shopping are not a part of bank statement.'
        ],
        accommodationCost: '',
        tuitionFee: [],
        availableIntakes: [],
        overlay: 2,

        component: (props) => <TimeTagWatch {...props} />
    },
    {
        id: 3,
        title: "United Kingdom (UK)",
        slug: 'uk',
        src: '/assets/img/country/uk.jpg',
        srcSlider: '/assets/img/country/uk.jpg',
        category: ['Europe'],
        description: 'Once the Country strategy was sharp and real for everyone inside of the company, all the Country behavior started to roll out as stationary material.',
        overlay: 2,
        description: `Whoever said “It’s not about the destination. It’s the journey” never flew on a long ...`,

        requirementsFor: 'For : Diploma, Advanced Diploma, Bachelor’s and Master’s.',
        documents: ['Academic documents - Scanned copy + Photocopy (Photocopy need to be notarized )',
            'Medium of Instruction - MOI (If applicable)',
            ' 6.0 for IELTS and 80 for TOEFL',
            'Curriculum Vitae',
            'Statement of Purpose ',
            'Recommendation letter (If required)'
        ],
        studyGap: ['No more than 8 academic years since last education(Can vary) '],
        funding: ['Bank statement with a maturity of 3 months : Must have 1 year tuition fee’s + living expense.'],
        breakdown: ['1. Bangladeshi Passport - Check local office for cost. ',
            '2. Police clearance- 500 Taka (We will provide service if required)',
            '3. Consultancy file opening fee - 10,000 Taka',
            '4. Application fee  Depends on choice of college/university.',
            '5. Tuition fee - Depends on choice of College/University. ',
            '6. Visa Application fee -  100 to 200 Pound',
            '7. Agency service charge - 45,000 Taka',
            '8. Air ticket - Depends (We can provide)',
        ],
        checklist: ['1. All documents photocopy need to be notarized. ',
            '2. Application fee, file opening fee cannot be refunded.',
            '3. Personal expenses like plane ticket and shopping are not a part of bank statement.'
        ],
        accommodationCost: ' between £4,500 to £9,000 per year.',
        tuitionFee: ['Diploma: Tuition fees for diploma programs can range from £6,000 to £15,000 per year.',
            "Bachelor: Tuition fees for bachelor's programs vary widely depending on the university and course, but they typically range from £10,000 to £25,000 per year.",
            "Master: Tuition fees for master's programs also vary depending on the university and course, but they generally range from £12,000 to £30,000 per year."
        ],
        availableIntakes: [" September/October"],
        component: (props) => <TimeTagWatch {...props} />
    },
    {
        id: 4,
        title: "Canada",
        slug: 'canada',
        category: ['North-America'],
        src: '/assets/img/country/canada.webp',
        srcSlider: '/assets/img/country/canada.webp',
        video: {
            poster: '/assets/img/country/canada.webp',
            loop: true
        },
        description: 'We are thrilled to share our new reel with you all! Special thanks to all of our talented friends.',
        overlay: 2,
        description: `Whoever said “It’s not about the destination. It’s the journey” never flew on a long ...`,

        requirementsFor: 'For : Diploma, Advanced Diploma, Bachelor’s and Master’s.',
        documents: ['Academic documents - Scanned copy + Photocopy (Photocopy need to be notarized )',
            'Medium of Instruction - MOI (If applicable)',
            'IELTS score - Starts from overall 5.5, No module less than 5. (Minimum 6.5 for science/commerce subjects at top universities)',
            'TOEFL ,PTE, MUET is accepted',
            'Curriculum Vitae',
            'Statement of Purpose ',
            'Reference letter',
            'Recommendation letter (If required)'
        ],
        studyGap: ['No more than 8 academic years since last education(Can vary) '],
        funding: ['Bank statement with a maturity of 3 months : Must have 1 year tuition fee’s + living expense.'],
        breakdown: [
            '1. Bangladeshi Passport - Check local office for cost.',
            '2. Police clearance- 500 Taka(We will provide service if required)',
            '3. Consultancy file opening fee - 7000 Taka',
            '4. Application fee  Depends on choice of college / university',
            '5. Tuition fee - Depends on choice of College / University.',
            '6. Health Insurance Fee for 1 year - 600 to 900 CAD',
            '7. Medical examination fee - 4500 Taka(under age 11), 5000taka(age 11 to 15), 8000taka(age 15 +)',
            '8. Visa Application fee - 19,000 Taka',
            '9. Agency service charge - 45,000 Taka',
            '10. Air ticket - Depends(We can provide)'

        ],
        checklist: ['1. All documents photocopy need to be notarized. ',
            '2. Application fee, file opening fee cannot be refunded.',
        ],
        accommodationCost: '',
        tuitionFee: [],
        availableIntakes: [],
        component: (props) => <TimeTagWatch {...props} />
    },
    {
        id: 5,
        title: "Australia",
        slug: 'australia',
        src: '/assets/img/country/australia.webp',
        srcSlider: '/assets/img/country/australia.webp',
        category: ['Australia',],
        description: 'Cal was first. The first public university in the great state of California. They are the pioneers. They are the trailblazers who started it all.',
        overlay: 2,
        description: `Whoever said “It’s not about the destination. It’s the journey” never flew on a long ...`,

        requirementsFor: 'For : Diploma, Advanced Diploma, Bachelor’s and Master’s.',
        documents: ['Academic documents - Scanned copy + Photocopy (Photocopy need to be notarized )',
            'Medium of Instruction - MOI (If applicable)',
            'IELTS score - Starts from overall 5.5, No module less than 5. (Minimum 6.5 for science/commerce subjects at top universities)',
            'TOEFL ,PTE, MUET is accepted',
            'Curriculum Vitae',
            'Statement of Purpose ',
            'Recommendation letter (If required)'
        ],
        studyGap: ['No more than 8 academic years since last education(Can vary) '],
        funding: ['Bank statement with a maturity of 3 months : Must have 1 year tuition fee’s + living expense.'],
        breakdown: ['1. Bangladeshi Passport - Check local office for cost. ',
            '2. Police clearance- 500 Taka (We will provide service if required)',
            '3. Consultancy file opening fee - 10,000 Taka',
            '4. Application fee  Depends on choice of college/university.',
            '5. Tuition fee - Depends on choice of College/University. ',
            '6. Visa Application fee -  100 to 200 AD',
            '7. Agency service charge - 45,000 Taka',
            '8. Air ticket - Depends (We can provide)',
        ],
        checklist: ['1. All documents photocopy need to be notarized. ',
            '2. Application fee, file opening fee cannot be refunded.',
            '3. Personal expenses like plane ticket and shopping are not a part of bank statement.'
        ],
        accommodationCost: '',
        tuitionFee: [],
        availableIntakes: [],
        component: (props) => <TimeTagWatch {...props} />
    },
    {
        id: 6,
        title: "Sweden",
        slug: 'sweden',
        category: ["Europe"],
        src: '/assets/img/country/Sweden.jpg',
        srcSlider: '/assets/img/country/Sweden.jpg',
        description: 'Striking and powerful Aston Martin Vantage captivates you at the first sight.',
        overlay: 2,
        description: `Whoever said “It’s not about the destination. It’s the journey” never flew on a long ...`,

        requirementsFor: 'For : Diploma, Advanced Diploma, Bachelor’s and Master’s.',
        documents: ['Academic documents - Scanned copy + Photocopy (Photocopy need to be notarized )',
            'Medium of Instruction - MOI (If applicable)',
            'IELTS score - Starts from overall 5.5, No module less than 5. (Minimum 6.5 for science/commerce subjects at top universities)',
            'TOEFL ,PTE, MUET is accepted',
            'Curriculum Vitae',
            'Statement of Purpose ',
            'Recommendation letter (If required)'
        ],
        studyGap: ['No more than 8 academic years since last education(Can vary) '],
        funding: ['Bank statement with a maturity of 3 months : Must have 1 year tuition fee’s + living expense.'],
        breakdown: ['1. Bangladeshi Passport - Check local office for cost. ',
            '2. Police clearance- 500 Taka (We will provide service if required)',
            '3. Consultancy file opening fee - 10,000 Taka',
            '4. Application fee  Depends on choice of college/university.',
            '5. Tuition fee - Depends on choice of College/University. ',
            '6. Visa Application fee - 2600 to 3500 RM',
            '7. Agency service charge - 45,000 Taka',
            '8. Air ticket - Depends (We can provide)',
        ],
        checklist: ['1. All documents photocopy need to be notarized. ',
            '2. Application fee, file opening fee cannot be refunded.',
            '3. Personal expenses like plane ticket and shopping are not a part of bank statement.'
        ],
        accommodationCost: '',
        tuitionFee: [],
        availableIntakes: [],
        component: (props) => <TimeTagWatch {...props} />
    },
    {
        id: 7,
        title: "Denmark",
        slug: 'denmark',
        category: ["Europe"],
        src: '/assets/img/country/Denmark.jpg',
        srcSlider: '/assets/img/country/Denmark.jpg',
        description: 'Cal was first. The first public university in the great state of California. They are the pioneers. They are the trailblazers who started it all.',
        overlay: 2,
        description: `Whoever said “It’s not about the destination. It’s the journey” never flew on a long ...`,

        requirementsFor: 'For : Diploma, Advanced Diploma, Bachelor’s and Master’s.',
        documents: ['Academic documents - Scanned copy + Photocopy (Photocopy need to be notarized )',
            'Medium of Instruction - MOI (If applicable)',
            'IELTS score - Starts from overall 5.5, No module less than 5. (Minimum 6.5 for science/commerce subjects at top universities)',
            'TOEFL ,PTE, MUET is accepted',
            'Curriculum Vitae',
            'Statement of Purpose ',
            'Recommendation letter (If required)'
        ],
        studyGap: ['No more than 8 academic years since last education(Can vary) '],
        funding: ['Bank statement with a maturity of 3 months : Must have 1 year tuition fee’s + living expense.'],
        breakdown: ['1. Bangladeshi Passport - Check local office for cost. ',
            '2. Police clearance- 500 Taka (We will provide service if required)',
            '3. Consultancy file opening fee - 10,000 Taka',
            '4. Application fee  Depends on choice of college/university.',
            '5. Tuition fee - Depends on choice of College/University. ',
            '6. Visa Application fee - 100 to 200 Euro',
            '7. Agency service charge - 45,000 Taka',
            '8. Air ticket - Depends (We can provide)',
        ],
        checklist: ['1. All documents photocopy need to be notarized. ',
            '2. Application fee, file opening fee cannot be refunded.',
            '3. Personal expenses like plane ticket and shopping are not a part of bank statement.'
        ],
        accommodationCost: '',
        tuitionFee: [],
        availableIntakes: [],
        component: (props) => <TimeTagWatch {...props} />
    },
    {
        id: 8,
        title: "Czech Republic",
        slug: 'czech-republi',
        category: ["Europe"],
        src: '/assets/img/country/CzechRepublic.avif',
        srcSlider: '/assets/img/country/CzechRepublic.avif',
        description: 'Cal was first. The first public university in the great state of California. They are the pioneers.',
        overlay: 2,
        description: `Whoever said “It’s not about the destination. It’s the journey” never flew on a long ...`,

        requirementsFor: 'For : Diploma, Advanced Diploma, Bachelor’s and Master’s.',
        documents: ['Academic documents - Scanned copy + Photocopy (Photocopy need to be notarized )',
            'Medium of Instruction - MOI (If applicable)',
            'IELTS score - Starts from overall 5.5, No module less than 5. (Minimum 6.5 for science/commerce subjects at top universities)',
            'TOEFL ,PTE, MUET is accepted',
            'Curriculum Vitae',
            'Statement of Purpose ',
            'Recommendation letter (If required)'
        ],
        studyGap: ['No more than 8 academic years since last education(Can vary) '],
        funding: ['Bank statement with a maturity of 3 months : Must have 1 year tuition fee’s + living expense.'],
        breakdown: ['1. Bangladeshi Passport - Check local office for cost. ',
            '2. Police clearance- 500 Taka (We will provide service if required)',
            '3. Consultancy file opening fee - 10,000 Taka',
            '4. Application fee  Depends on choice of college/university.',
            '5. Tuition fee - Depends on choice of College/University. ',
            '6. Visa Application fee -  100 to 200 Euro',
            '7. Agency service charge - 45,000 Taka',
            '8. Air ticket - Depends (We can provide)',
        ],
        checklist: ['1. All documents photocopy need to be notarized. ',
            '2. Application fee, file opening fee cannot be refunded.',
            '3. Personal expenses like plane ticket and shopping are not a part of bank statement.'
        ],
        accommodationCost: '',
        tuitionFee: [],
        availableIntakes: [],
        component: (props) => <TimeTagWatch {...props} />
    },
    {
        id: 9,
        title: "Romania",
        slug: 'bastian-bux',

        description: 'Bastian bux is the consequence of reducing everything surrounding a dj and producer to its essential element: the music.',
        category: ["Europe"],
        src: '/assets/img/country/Romania.jpg',
        srcSlider: '/assets/img/country/Romania.jpg',
        overlay: 2,
        description: `Whoever said “It’s not about the destination. It’s the journey” never flew on a long ...`,

        requirementsFor: 'For : Diploma, Advanced Diploma, Bachelor’s and Master’s.',
        documents: ['Academic documents - Scanned copy + Photocopy (Photocopy need to be notarized )',
            'Medium of Instruction - MOI (If applicable)',
            'IELTS score - Starts from overall 5.5, No module less than 5. (Minimum 6.5 for science/commerce subjects at top universities)',
            'TOEFL ,PTE, MUET is accepted',
            'Curriculum Vitae',
            'Statement of Purpose ',
            'Recommendation letter (If required)'
        ],
        studyGap: ['No more than 8 academic years since last education(Can vary) '],
        funding: ['Bank statement with a maturity of 3 months : Must have 1 year tuition fee’s + living expense.'],
        breakdown: ['1. Bangladeshi Passport - Check local office for cost. ',
            '2. Police clearance- 500 Taka (We will provide service if required)',
            '3. Consultancy file opening fee - 10,000 Taka',
            '4. Application fee  Depends on choice of college/university.',
            '5. Tuition fee - Depends on choice of College/University. ',
            '6. Visa Application fee - 100 to 200 Euro',
            '7. Agency service charge - 45,000 Taka',
            '8. Air ticket - Depends (We can provide)',
        ],
        checklist: ['1. All documents photocopy need to be notarized. ',
            '2. Application fee, file opening fee cannot be refunded.',
            '3. Personal expenses like plane ticket and shopping are not a part of bank statement.'
        ],
        accommodationCost: '',
        tuitionFee: [],
        availableIntakes: [],
        component: (props) => <TimeTagWatch {...props} />
    },
    {
        id: 10,
        title: "Cyprus",
        slug: 'cyprus',

        description: 'StudyGram is the consequence of reducing everything surrounding a dj and producer to its essential element: the music.',
        category: ["Europe"],
        src: '/assets/img/country/Cyprus.jpg',
        srcSlider: '/assets/img/country/Cyprus.jpg',
        overlay: 2,
        description: `Whoever said “It’s not about the destination. It’s the journey” never flew on a long ...`,

        requirementsFor: 'For : Diploma, Advanced Diploma, Bachelor’s and Master’s.',
        documents: ['Academic documents - Scanned copy + Photocopy (Photocopy need to be notarized )',
            'Medium of Instruction - MOI (If applicable)',
            'IELTS score - Starts from overall 5.5, No module less than 5. (Minimum 6.5 for science/commerce subjects at top universities)',
            'TOEFL ,PTE, MUET is accepted',
            'Curriculum Vitae',
            'Statement of Purpose ',
            'Recommendation letter (If required)'
        ],
        studyGap: ['No more than 8 academic years since last education(Can vary) '],
        funding: ['Bank statement with a maturity of 3 months : Must have 1 year tuition fee’s + living expense.'],
        breakdown: ['1. Bangladeshi Passport - Check local office for cost. ',
            '2. Police clearance- 500 Taka (We will provide service if required)',
            '3. Consultancy file opening fee - 10,000 Taka',
            '4. Application fee  Depends on choice of college/university.',
            '5. Tuition fee - Depends on choice of College/University. ',
            '6. Visa Application fee - 100 to 200 Euro',
            '7. Agency service charge - 45,000 Taka',
            '8. Air ticket - Depends (We can provide)',
        ],
        checklist: ['1. All documents photocopy need to be notarized. ',
            '2. Application fee, file opening fee cannot be refunded.',
            '3. Personal expenses like plane ticket and shopping are not a part of bank statement.'
        ],
        accommodationCost: ' €3,000 to €6,000 per year ',
        tuitionFee: ["Diploma: Tuition fees for diploma programs can range from €2,000 to €5,000 per year.",
            "Bachelor: Tuition fees for bachelor's programs typically range from €3,000 to €8,000 per year.",
            "Master: Tuition fees for master's programs generally range from €4,000 to €10,000 per year."
        ],
        availableIntakes: ["Fall intake: Starting in September",
            "Spring intake: Starting in February or March"
        ],
        component: (props) => <TimeTagWatch {...props} />
    },
]

export const getPortfolioData = () => data;

export const getPortfolioItem = (value, whereName = "id") => {
    return data.find(item => {
        if (item[whereName] === value) return item;
        return null;
    });
};
export const getPortfolioLink = (item) => {
    if (item)
        return item.slug && '/country/' + item.slug;

    return '';
};